import { render, staticRenderFns } from "./HoverMask.vue?vue&type=template&id=60b4e50f&scoped=true"
import script from "./HoverMask.vue?vue&type=script&lang=js"
export * from "./HoverMask.vue?vue&type=script&lang=js"
import style0 from "./HoverMask.vue?vue&type=style&index=0&id=60b4e50f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b4e50f",
  null
  
)

export default component.exports